<template>
  <div style="position: fixed; right: 0">
    <!-- <div class="jt1" @click="sds" id="positon" v-if="Show">
      <img
        src="../../../assets/images/jtz.png"
        alt=""
        style="width: 75%; margin: 5px 0 0 5px"
      />
    </div>
    <div class="jt" @click="sdss" v-if="ShowOne">
      <img
        src="../../../assets/images/jty.png"
        alt=""
        style="width: 75%; margin: 5px 0 0 5px"
      />
    </div>

    <Drawer :closable="false" v-model="value1" :mask="false" :scrollable="true">
      <div id="floatDivBoxs">
        <div class="floatDtt">在線客服</div>
        <div class="floatShadow">
          <ul class="floatDqq">
            <li style="padding-left: 0px">
            
                <img
                  src="../../../assets/images/whatsapp.png"
                  height="16"
                  border="0"
                  alt="whatsapp"
                  align="absmiddle"
                />
                &nbsp;&nbsp;微信：15012573996
            </li>
            <li style="padding-left: 0px">
              <a
                href="https://m.me/10533192155084"
                target="_blank"
              >
                <img
                  src="../../../assets/images/whatsapp.png"
                  height="16"
                  border="0"
                  alt="whatsapp"
                  align="absmiddle"
                />
                &nbsp;&nbsp;天鳥集運</a
              >
            </li>
          </ul>
        </div> -->
      <!-- </div>
    </Drawer> -->
    <!-- <sidebar-menu :menu="menu" /> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      value1: false,
      Show: true,
      ShowOne: false,
      // menu: [
      //   {
      //     href: "/",
      //     title: "Dashboard",
      //     icon: "fa fa-user",
      //   },
      //   {
      //     href: "#",
      //     title: "Charts",
      //     icon: "fa fa-chart-area",
      //   },
      // ],
      // value2: false,
      // value2:false
    };
  },
  methods: {
    sds() {
      this.value1 = true;
      console.log(this.value1);
      this.Show = false;
      this.ShowOne = true;
    },
    sdss() {
      this.value1 = false;
      this.Show = true;
      this.ShowOne = false;
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .ivu-drawer-content {
  box-shadow: none !important;
  background-color: #fff0 !important;
}
/deep/ .ivu-drawer-content {
  width: 1%;
  height: 1%;
}
.jt1{
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  // top: 0;
  right: 0;
  background: #f0c026;
  border: 1px solid #00000026;
}
.jt {
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  right: 163px;
  background: #f0c026;
}
.one {
  position: relative;
  left: -200px;
}
#floatDivBoxs {
  width: 170px;
  background: #fff;
  position: fixed;
  top: 180px;
  right: 0;
  z-index: 999;
}
#floatDivBoxs .floatDtt {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: #f08326;
  color: #fff;
  font-size: 18px;
  text-indent: 22px;
  position: relative;
}
#floatDivBoxs .floatDqq {
  padding: 0 14px;
}
#floatDivBoxs .floatDqq li {
  height: 45px;
  line-height: 45px;
  // font-size: 15px;
  border-bottom: 1px solid #e3e3e3;
  padding: 0 0 0 50px;
}
a {
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}
#floatDivBoxs .floatDqq li a {
  color: #333;
}
#floatDivBoxs .floatDtxt {
  font-size: 18px;
  color: #333;
  padding: 12px 14px;
}
#floatDivBoxs .floatDtel {
  padding: 0 0 15px 10px;
  color: #f08326;
  font-size: 18px;
}
#floatDivBoxs .floatDbg {
  width: 100%;
  height: 20px;
  background: url("../../../assets/images/online_botbg.jpg") no-repeat;
  box-shadow: -2px 0 3px rgba(0, 0, 0, 0.25);
}
#floatDivBoxs .floatDewm {
  text-align: center;
  padding: 10px 0 5px 0;
  background: #ebebeb;
  color: #333;
}
#floatDivBoxs .floatDewm img {
  width: 106px;
  height: 106px;
}
</style>


// WEBPACK FOOTER //
// src/pages/layout/sideone/index.vue